var map = {
	"./bmw.svg": "cf74",
	"./jdp.svg": "537b",
	"./long-logo.svg": "1706",
	"./manheim.svg": "6721",
	"./mid.svg": "0c15",
	"./newlogo.svg": "306c",
	"./newlogoheader.svg": "d059",
	"./pro.svg": "734f",
	"./starter.svg": "ce04",
	"./user-desktop-bg.svg": "17f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";